export default {
  getXeroInvoice: (state) => state.xeroInvoice,
};
